import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'who_receives_comm_and_training_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'who_receives_comm_and_training_select_all_that_apply',
  name: 'Who receives communication and training?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SENIOR_MANAGEMENT',
      text: 'Senior management',
      externalIds: [
        {
          id: 'ms-5--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDIVIDUALS_RESPONSIBLE_FOR_IMPLEMENTATION',
      text: 'Individuals responsible for implementation',
      externalIds: [
        {
          id: 'ms-5--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NEW_PRODUCTION_WORKERS',
      text: 'NEW Production workers',
      externalIds: [
        {
          id: 'ms-do-28',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EXISTING_PRODUCTION_WORKERS',
      text: 'EXISTING Production workers',
      externalIds: [
        {
          id: 'ms-do-29',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SECURITY_GUARDS',
      text: 'Security guards',
      externalIds: [
        {
          id: 'ms-5--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SUBCONTRACTORS_SUPPLIERS',
      text: 'Subcontractors / Suppliers',
      externalIds: [
        {
          id: 'ms-5--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--1-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'SENIOR_MANAGEMENT',
                'INDIVIDUALS_RESPONSIBLE_FOR_IMPLEMENTATION',
                'NEW_PRODUCTION_WORKERS',
                'EXISTING_PRODUCTION_WORKERS',
                'SECURITY_GUARDS',
                'SUBCONTRACTORS_SUPPLIERS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-7',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21380,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
